var currentMobileCols = 2;

function switchGridMobileCols(cols, triggerEvent) {
  if (currentMobileCols === cols) {
    return;
  }

  const control =
    triggerEvent && triggerEvent.currentTarget
      ? triggerEvent.currentTarget
      : null;

  const group = control
    ? control.closest('[data-grid-controls], div')
    : null;

  const buttons = group
    ? group.querySelectorAll('.js-grid-buttons')
    : [];

  for (const button of buttons) {
    button.classList.toggle('cursor-pointer');
    button.classList.toggle('pointer-events-none');
    button.classList.toggle('opacity-30');
  }

  document.querySelectorAll('.js-injection').forEach((injection) => {
    if (!injection.classList.contains('js-single-mobile')) {
      injection.classList.toggle('col-span-2');
    }
  });

  document.querySelectorAll('.js-heart').forEach((heart) => {
    heart.classList.toggle('hidden');
  });

  const productList = document.getElementById('productList');

  if (productList) {
    productList.classList.toggle('grid-cols-2');
    productList.classList.toggle('grid-cols-1');
  }

  currentMobileCols = cols;
}

function filterAccordion(initialOpen = false) {
  return {
    open: Boolean(initialOpen),
    selectedCount: 0,

    init() {
      this.refresh();
      this.$nextTick(() => this.refresh());
    },

    refresh() {
      const checkedOptions = this.$el.querySelectorAll(
        'input[type="checkbox"]:checked'
      ).length;

      const hasPriceValue = [
        ...this.$el.querySelectorAll(
          '[data-price-range] input[type="hidden"]'
        ),
      ].some((input) => input.value !== '');

      this.selectedCount =
        checkedOptions + (hasPriceValue ? 1 : 0);
    },
  };
}

function collectionPriceRange({
  floor,
  ceiling,
  initialMinimum,
  initialMaximum,
  step = 1,
  currency,
  storageKey = '',
  legacyStorageKey = '',
  floorUrl = '',
  resolveImmediately = false,
}) {
  const serverFloor = Math.max(0, Number(floor) || 0);
  const upperBound = Math.max(
    serverFloor,
    Number(ceiling) || serverFloor
  );
  const increment = Math.max(0.01, Number(step) || 1);
  const cacheLifetime = 30 * 60 * 1000;

  let lowerBound = serverFloor;
  let cachedFloor = null;
  let hasValidCachedFloor = false;

  if (legacyStorageKey) {
    try {
      window.sessionStorage.removeItem(legacyStorageKey);
    } catch (error) {
      // Storage is optional. The server-rendered floor remains authoritative.
    }
  }

  if (storageKey) {
    try {
      const cachedValue = window.sessionStorage.getItem(storageKey);

      if (cachedValue) {
        const cachedPayload = JSON.parse(cachedValue);
        const candidateFloor = Number(cachedPayload?.floor);
        const savedAt = Number(cachedPayload?.savedAt);
        const cacheIsFresh =
          Number.isFinite(savedAt) &&
          Date.now() - savedAt < cacheLifetime;

        const candidateIsValid =
          Number.isFinite(candidateFloor) &&
          candidateFloor >= 0 &&
          candidateFloor <= upperBound &&
          !(serverFloor > 0 && candidateFloor === 0);

        if (cacheIsFresh && candidateIsValid) {
          cachedFloor = candidateFloor;
          lowerBound =
            serverFloor > 0
              ? Math.min(serverFloor, candidateFloor)
              : candidateFloor;

          hasValidCachedFloor =
            candidateFloor <= serverFloor || serverFloor === 0;
        } else {
          window.sessionStorage.removeItem(storageKey);
        }
      }
    } catch (error) {
      try {
        window.sessionStorage.removeItem(storageKey);
      } catch (storageError) {
        // Ignore storage failures and continue with server-rendered values.
      }
    }
  }

  const clamp = (value, minimum, maximum) => {
    const numericValue = Number(value);

    return Math.min(
      Math.max(
        Number.isFinite(numericValue) ? numericValue : minimum,
        minimum
      ),
      maximum
    );
  };

  const alignToStep = (value, origin = lowerBound) => {
    const numeric = clamp(value, origin, upperBound);

    // Preserve exact price endpoints (which may include pence), even
    // when intermediate slider values snap to whole currency units.
    if (numeric <= origin + increment / 2) return origin;
    if (numeric >= upperBound - increment / 2) return upperBound;

    const aligned =
      Math.round((numeric - origin) / increment) * increment +
      origin;

    return clamp(
      Number(aligned.toFixed(increment < 1 ? 2 : 0)),
      origin,
      upperBound
    );
  };

  const toInputValue = (value) => {
    const decimals = increment < 1 ? 2 : 0;

    return Number(value)
      .toFixed(decimals)
      .replace(/\.00$/, '')
      .replace(/(\.\d*[1-9])0+$/, '$1');
  };

  const parseDraftValue = (value) => {
    const rawValue = String(value ?? '').trim();

    if (rawValue === '') {
      return null;
    }

    const cleanedValue = rawValue
      .replace(/\s+/g, '')
      .replace(/[^0-9,.-]/g, '');

    if (
      cleanedValue === '' ||
      cleanedValue === '-' ||
      cleanedValue === '.' ||
      cleanedValue === ',' ||
      cleanedValue === '-.' ||
      cleanedValue === '-,'
    ) {
      return Number.NaN;
    }

    const commaIndex = cleanedValue.lastIndexOf(',');
    const dotIndex = cleanedValue.lastIndexOf('.');
    let normalisedValue = cleanedValue;

    if (commaIndex >= 0 && dotIndex >= 0) {
      normalisedValue =
        commaIndex > dotIndex
          ? cleanedValue.replace(/\./g, '').replace(',', '.')
          : cleanedValue.replace(/,/g, '');
    } else if (commaIndex >= 0) {
      const commaParts = cleanedValue.split(',');
      const looksLikeThousands =
        commaParts.length > 2 ||
        (commaParts.length === 2 &&
          commaParts[1].length === 3 &&
          commaParts[0].replace('-', '').length <= 3);

      normalisedValue = looksLikeThousands
        ? cleanedValue.replace(/,/g, '')
        : cleanedValue.replace(',', '.');
    }

    const numericValue = Number(normalisedValue);

    return Number.isFinite(numericValue)
      ? numericValue
      : Number.NaN;
  };

  const hasInitialMinimum =
    initialMinimum !== null &&
    initialMinimum !== '' &&
    Number.isFinite(Number(initialMinimum));

  const hasInitialMaximum =
    initialMaximum !== null &&
    initialMaximum !== '' &&
    Number.isFinite(Number(initialMaximum));

  let minimum = alignToStep(
    clamp(
      hasInitialMinimum ? initialMinimum : lowerBound,
      lowerBound,
      upperBound
    )
  );

  let maximum = alignToStep(
    clamp(
      hasInitialMaximum ? initialMaximum : upperBound,
      lowerBound,
      upperBound
    )
  );

  if (minimum > maximum) {
    [minimum, maximum] = [maximum, minimum];
  }

  return {
    floor: lowerBound,
    ceiling: upperBound,
    step: increment,
    minimum,
    maximum,
    minimumDraft: toInputValue(minimum),
    maximumDraft: toInputValue(maximum),
    minimumEditing: false,
    maximumEditing: false,
    currency,
    floorUrl,
    floorLoading: false,
    floorResolved: hasValidCachedFloor,
    hasInitialMinimum,
    hasInitialMaximum,

    init() {
      this.syncDrafts(true);

      if (resolveImmediately) {
        this.resolveFloor();
      }
    },

    syncDrafts(force = false) {
      if (force || !this.minimumEditing) {
        this.minimumDraft = toInputValue(this.minimum);
      }

      if (force || !this.maximumEditing) {
        this.maximumDraft = toInputValue(this.maximum);
      }
    },

    applyFloor(value) {
      const numericFloor = Number(value);

      if (
        !Number.isFinite(numericFloor) ||
        numericFloor < 0 ||
        numericFloor > this.ceiling
      ) {
        return;
      }

      const previousFloor = this.floor;
      const decimals = this.step < 1 ? 2 : 0;

      this.floor = Number(numericFloor.toFixed(decimals));

      if (!this.hasInitialMinimum || this.minimum <= previousFloor) {
        this.minimum = this.floor;
      } else {
        this.minimum = alignToStep(
          clamp(this.minimum, this.floor, this.maximum),
          this.floor
        );
      }

      if (this.maximum < this.floor) {
        this.maximum = this.floor;
      } else {
        this.maximum = alignToStep(
          clamp(this.maximum, this.minimum, this.ceiling),
          this.floor
        );
      }

      this.syncDrafts();
    },

    async resolveFloor() {
      if (
        this.floorResolved ||
        this.floorLoading ||
        !this.floorUrl
      ) {
        return;
      }

      this.floorLoading = true;

      try {
        const requestUrl = new URL(
          this.floorUrl,
          window.location.href
        );

        const previewThemeId = new URL(
          window.location.href
        ).searchParams.get('preview_theme_id');

        if (previewThemeId) {
          requestUrl.searchParams.set(
            'preview_theme_id',
            previewThemeId
          );
        }

        const response = await fetch(requestUrl.toString(), {
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
        });

        if (!response.ok) {
          throw new Error(
            `Price floor could not be loaded (${response.status}).`
          );
        }

        const responseText = await response.text();
        let payload;

        try {
          payload = JSON.parse(responseText.trim());
        } catch (error) {
          throw new Error(
            'Price floor returned an unexpected response.'
          );
        }

        const resolvedFloor = Number(payload.floor);

        if (
          !Number.isFinite(resolvedFloor) ||
          resolvedFloor < 0 ||
          resolvedFloor > this.ceiling
        ) {
          throw new Error('Price floor returned an invalid value.');
        }

        this.applyFloor(resolvedFloor);
        this.floorResolved = true;

        if (storageKey) {
          try {
            window.sessionStorage.setItem(
              storageKey,
              JSON.stringify({
                floor: this.floor,
                savedAt: Date.now(),
              })
            );
          } catch (error) {
            // Storage is optional; the resolved in-memory value is sufficient.
          }
        }
      } catch (error) {
        this.applyFloor(0);
        this.floorResolved = true;
      } finally {
        this.floorLoading = false;
      }
    },

    beginMinimumEdit() {
      this.minimumEditing = true;
    },

    beginMaximumEdit() {
      this.maximumEditing = true;
    },

    updateMinimumFromDraft() {
      const parsedValue = parseDraftValue(this.minimumDraft);

      if (parsedValue === null) {
        this.minimum = this.floor;
        return;
      }

      if (!Number.isFinite(parsedValue)) {
        return;
      }

      this.minimum = clamp(
        parsedValue,
        this.floor,
        this.maximum
      );
    },

    updateMaximumFromDraft() {
      const parsedValue = parseDraftValue(this.maximumDraft);

      if (parsedValue === null) {
        this.maximum = this.ceiling;
        return;
      }

      if (!Number.isFinite(parsedValue)) {
        return;
      }

      this.maximum = clamp(
        parsedValue,
        this.minimum,
        this.ceiling
      );
    },

    commitMinimumDraft() {
      const parsedValue = parseDraftValue(this.minimumDraft);

      if (parsedValue === null) {
        this.minimum = this.floor;
      } else if (Number.isFinite(parsedValue)) {
        this.minimum = alignToStep(
          clamp(parsedValue, this.floor, this.maximum),
          this.floor
        );
      }

      this.minimumEditing = false;
      this.minimumDraft = toInputValue(this.minimum);
    },

    commitMaximumDraft() {
      const parsedValue = parseDraftValue(this.maximumDraft);

      if (parsedValue === null) {
        this.maximum = this.ceiling;
      } else if (Number.isFinite(parsedValue)) {
        this.maximum = alignToStep(
          clamp(parsedValue, this.minimum, this.ceiling),
          this.floor
        );
      }

      this.maximumEditing = false;
      this.maximumDraft = toInputValue(this.maximum);
    },

    constrainMinimum() {
      this.minimum = alignToStep(
        clamp(this.minimum, this.floor, this.maximum),
        this.floor
      );
    },

    constrainMaximum() {
      this.maximum = alignToStep(
        clamp(this.maximum, this.minimum, this.ceiling),
        this.floor
      );
    },

    updateMinimumFromSlider() {
      this.constrainMinimum();
      this.minimumDraft = toInputValue(this.minimum);
    },

    updateMaximumFromSlider() {
      this.constrainMaximum();
      this.maximumDraft = toInputValue(this.maximum);
    },

    normaliseMinimum() {
      this.updateMinimumFromSlider();
    },

    normaliseMaximum() {
      this.updateMaximumFromSlider();
    },

    clearBound(name) {
      if (name && name.includes('gte')) {
        this.minimum = this.floor;
        this.minimumDraft = toInputValue(this.minimum);
      } else if (name && name.includes('lte')) {
        this.maximum = this.ceiling;
        this.maximumDraft = toInputValue(this.maximum);
      }
    },

    format(value) {
      try {
        return new Intl.NumberFormat(
          document.documentElement.lang || 'en-GB',
          {
            style: 'currency',
            currency: this.currency,
            minimumFractionDigits: 0,
            maximumFractionDigits: this.step < 1 ? 2 : 0,
          }
        ).format(Number(value) || 0);
      } catch (error) {
        return String(Number(value) || 0);
      }
    },

    toParameter(value) {
      const decimals = this.step < 1 ? 2 : 0;

      return Number(value)
        .toFixed(decimals)
        .replace(/\.00$/, '');
    },

    get rangeSpan() {
      return Math.max(this.ceiling - this.floor, this.step);
    },

    get minimumPercent() {
      return Math.min(
        100,
        Math.max(
          0,
          ((this.minimum - this.floor) / this.rangeSpan) * 100
        )
      );
    },

    get maximumPercent() {
      return Math.min(
        100,
        Math.max(
          0,
          ((this.maximum - this.floor) / this.rangeSpan) * 100
        )
      );
    },

    get minimumParameter() {
      return this.minimum > this.floor
        ? this.toParameter(this.minimum)
        : '';
    },

    get maximumParameter() {
      return this.maximum < this.ceiling
        ? this.toParameter(this.maximum)
        : '';
    },
  };
}

function collectionFilters({
  sectionId,
  collectionPath,
  defaultSort,
  initialSort,
  saleMode = false,
}) {
  const STATE_VERSION = 2;
  const STATE_PREFIX = 'faf:collection-position:v2:';
  const LEGACY_PREFIX = 'faf:collection-state:v1:';
  const STATE_LIFETIME = 30 * 60 * 1000;
  const MAX_RESTORE_PAGES = 12;
  const RETURN_MARKER_KEY = 'faf:collection-return-pending';

  const safeStorage = {
    get(key) {
      try {
        return window.sessionStorage.getItem(key);
      } catch (error) {
        return null;
      }
    },

    set(key, value) {
      try {
        window.sessionStorage.setItem(key, value);
        return true;
      } catch (error) {
        return false;
      }
    },

    remove(key) {
      try {
        window.sessionStorage.removeItem(key);
      } catch (error) {
        // Storage is optional.
      }
    },
  };

  const productCards = () =>
    Array.from(
      document.querySelectorAll(
        '#productList [data-collection-product], ' +
        '#productList .faf-product-card-render[data-product-id]'
      )
    );

  const productHandle = (card) => {
    if (!card) return '';
    if (card.dataset.productHandle) return card.dataset.productHandle;

    const link = card.querySelector('a[href*="/products/"]');
    if (!link) return '';

    try {
      const parts = new URL(
        link.href,
        window.location.origin
      ).pathname.split('/products/');

      return String(parts[1] || '')
        .split('/')[0]
        .split('?')[0];
    } catch (error) {
      return '';
    }
  };

  const cardIdentity = (card) => ({
    id: String(card?.dataset?.productId || ''),
    handle: productHandle(card),
  });

  const sameIdentity = (card, identity = {}) => {
    if (!card) return false;

    const current = cardIdentity(card);

    if (
      identity.id &&
      current.id === String(identity.id)
    ) {
      return true;
    }

    return Boolean(
      identity.handle &&
      current.handle === String(identity.handle)
    );
  };

  const nearestVisibleCard = (cards) => {
    const firstVisible = cards.find(
      (card) => card.getBoundingClientRect().bottom > 0
    );

    return firstVisible || cards[0] || null;
  };

  const waitForLayout = async () => {
    if (document.fonts?.ready) {
      await Promise.race([
        document.fonts.ready,
        new Promise((resolve) =>
          window.setTimeout(resolve, 350)
        ),
      ]).catch(() => { });
    }

    await new Promise((resolve) => {
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(resolve);
      });
    });
  };

  const announce = (message) => {
    const live = document.querySelector(
      '[data-collection-progress-live]'
    );

    if (live) {
      live.textContent = message;
    }
  };

  return {
    sectionId,
    collectionPath,
    defaultSort,
    sortBy: initialSort || defaultSort,
    saleMode: Boolean(saleMode),
    page: 1,
    show: false,
    loading: false,
    loadingMore: false,
    dirty: false,
    error: '',
    requestController: null,
    loadMoreController: null,
    returnFocusElement: null,
    scrollLockKey: `collection-filter-${sectionId}`,
    scrollLocked: false,
    unlockTimer: null,

    stateVersion: STATE_VERSION,
    stateLifetime: STATE_LIFETIME,
    stateCachePrefix: STATE_PREFIX,
    restoringPosition: false,
    savedProductAnchor: null,
    savedProductAnchorAt: 0,
    listenersBound: false,
    pageHideHandler: null,
    pageShowHandler: null,
    productClickHandler: null,
    filterInputHandler: null,

    async init() {
      this.normaliseCurrentBrowserSaleHelpers();
      this.page = this.pageFromUrl();
      this.bindStateListeners();
      this.bindFilterInputListener();
      this.pruneCollectionStateCache();

      const restored = await this.restoreCollectionState();

      this.$nextTick(() => {
        this.updateCollectionProgress();

        if (!restored) {
          this.saveCollectionState();
        }
      });
    },

    destroy() {
      this.requestController?.abort();
      this.loadMoreController?.abort();
      this.unbindFilterInputListener();
      this.unbindStateListeners();
      this.releaseScrollLock(false);
    },

    pageFromUrl(url = window.location.href) {
      const page = Number.parseInt(
        new URL(url, window.location.origin).searchParams.get('page') ||
        '1',
        10
      );

      return Number.isFinite(page) && page > 0 ? page : 1;
    },

    currentRelativeUrl() {
      const url = new URL(window.location.href);
      url.hash = '';
      url.searchParams.delete('section_id');

      return `${url.pathname}${url.search}`;
    },

    collectionStateKey() {
      return `${STATE_PREFIX}${this.currentRelativeUrl()}`;
    },

    bindStateListeners() {
      if (this.listenersBound) return;

      this.pageHideHandler = () => {
        const recentAnchor =
          this.savedProductAnchor &&
            Date.now() - this.savedProductAnchorAt < 5 * 60 * 1000
            ? this.savedProductAnchor
            : null;

        this.saveCollectionState({ anchor: recentAnchor });
      };

      this.pageShowHandler = async (event) => {
        if (!event.persisted || this.restoringPosition) return;

        this.page = Math.max(
          this.page,
          this.pageFromUrl()
        );

        await new Promise((resolve) => {
          window.requestAnimationFrame(() => {
            window.requestAnimationFrame(resolve);
          });
        });

        const restored = await this.restoreCollectionState({
          force: true,
        });

        if (!restored) {
          this.updateCollectionProgress();
        }
      };

      this.productClickHandler = (event) => {
        const target =
          event.target instanceof Element
            ? event.target
            : null;

        const productLink = target?.closest(
          '#productList a[href*="/products/"]'
        );

        const card = productLink?.closest(
          '[data-collection-product], ' +
          '.faf-product-card-render[data-product-id]'
        );

        if (!card) return;

        const anchor = this.buildProductAnchor(card);
        this.savedProductAnchor = anchor;
        this.savedProductAnchorAt = Date.now();

        this.saveCollectionState({
          anchor,
          force: true,
        });

        safeStorage.set(
          RETURN_MARKER_KEY,
          JSON.stringify({
            url: this.currentRelativeUrl(),
            savedAt: Date.now(),
          })
        );
      };

      window.addEventListener(
        'pagehide',
        this.pageHideHandler
      );
      window.addEventListener(
        'pageshow',
        this.pageShowHandler
      );
      document.addEventListener(
        'click',
        this.productClickHandler,
        true
      );

      this.listenersBound = true;
    },

    unbindStateListeners() {
      if (!this.listenersBound) return;

      if (this.pageHideHandler) {
        window.removeEventListener(
          'pagehide',
          this.pageHideHandler
        );
      }

      if (this.pageShowHandler) {
        window.removeEventListener(
          'pageshow',
          this.pageShowHandler
        );
      }

      if (this.productClickHandler) {
        document.removeEventListener(
          'click',
          this.productClickHandler,
          true
        );
      }

      this.pageHideHandler = null;
      this.pageShowHandler = null;
      this.productClickHandler = null;
      this.listenersBound = false;
    },

    saleSizeInputs() {
      return [
        ...document.querySelectorAll(
          '#SaleFilters input[name="filter.v.m.faf.in_stock"], ' +
          '[data-collection-filter-form] input[name="filter.v.m.faf.in_stock"]'
        ),
      ];
    },

    normaliseGenderedSaleSizes(changedInput, root) {
      if (
        !(changedInput instanceof HTMLInputElement) ||
        !changedInput.checked
      ) {
        return;
      }

      const selectedGender = changedInput.dataset.gender || '';

      if (!selectedGender || !root) return;

      root
        .querySelectorAll(
          'input[name="filter.v.m.faf.in_stock"]:checked'
        )
        .forEach((input) => {
          if (
            input !== changedInput &&
            input.dataset.gender &&
            input.dataset.gender !== selectedGender
          ) {
            input.checked = false;
          }
        });
    },

    applySaleSizeHelpers(parameters, root) {
      if (!this.saleMode || !root) return parameters;

      const sizeParameter = 'filter.v.m.faf.in_stock';
      const genderParameter = 'filter.p.m.faf.new_gender';

      const selectedSizes = [
        ...root.querySelectorAll(
          `input[name="${sizeParameter}"]:checked`
        ),
      ].filter((input) => input.value !== 'One Size');

      /*
       * Rebuild this parameter from the visible inputs so that
       * the hidden One Size helper is never duplicated.
       */
      parameters.delete(sizeParameter);

      selectedSizes.forEach((input) => {
        parameters.append(sizeParameter, input.value);
      });

      parameters.delete(genderParameter);

      const selectedGenders = new Set(
        selectedSizes
          .map((input) => input.dataset.gender)
          .filter(
            (gender) =>
              gender === 'Mens' || gender === 'Womens'
          )
      );

      if (selectedGenders.size === 1) {
        parameters.set(
          genderParameter,
          [...selectedGenders][0]
        );
      }

      const hasFootwearSize = selectedSizes.some(
        (input) => input.dataset.sizeGroup === 'footwear'
      );

      if (hasFootwearSize) {
        parameters.append(sizeParameter, 'One Size');
      }

      return parameters;
    },

    normaliseSaleHelperParameters(parameters) {
      const sizeParameter = 'filter.v.m.faf.in_stock';
      const genderParameter = 'filter.p.m.faf.new_gender';
      const helperValue = 'One Size';

      if (!parameters.has(sizeParameter)) {
        if (this.saleMode) {
          parameters.delete(genderParameter);
        }

        return parameters;
      }

      const selectedSizes = parameters
        .getAll(sizeParameter)
        .filter((value) => value !== helperValue);

      /*
       * Mens/Womens and One Size are dependent helpers. They must
       * disappear as soon as no genuine size remains, even if the
       * collection was initialised without saleMode.
       */
      if (selectedSizes.length === 0) {
        parameters.delete(sizeParameter);
        parameters.delete(genderParameter);
        return parameters;
      }

      if (!this.saleMode) {
        return parameters;
      }

      const sizeInputs = this.saleSizeInputs();

      const matchingSizeInputs = selectedSizes.flatMap(
        (value) =>
          sizeInputs.filter((input) => input.value === value)
      );

      /*
       * If the current markup does not expose the selected values,
       * retain the server-provided helper state rather than guessing.
       */
      if (matchingSizeInputs.length === 0) {
        return parameters;
      }

      const matchingFootwearInputs = matchingSizeInputs.filter(
        (input) => input.dataset.sizeGroup === 'footwear'
      );

      const footwearGenders = new Set(
        matchingFootwearInputs
          .map((input) => input.dataset.gender)
          .filter(
            (gender) =>
              gender === 'Mens' || gender === 'Womens'
          )
      );

      parameters.delete(sizeParameter);

      [...new Set(selectedSizes)].forEach((value) => {
        parameters.append(sizeParameter, value);
      });

      if (matchingFootwearInputs.length > 0) {
        parameters.append(sizeParameter, helperValue);

        if (footwearGenders.size === 1) {
          parameters.set(
            genderParameter,
            [...footwearGenders][0]
          );
        } else if (
          !footwearGenders.has(
            parameters.get(genderParameter)
          )
        ) {
          parameters.delete(genderParameter);
        }
      } else {
        parameters.delete(genderParameter);
      }

      return parameters;
    },

    normaliseCurrentBrowserSaleHelpers() {
      const currentUrl = new URL(window.location.href);
      const before = currentUrl.searchParams.toString();

      this.normaliseSaleHelperParameters(
        currentUrl.searchParams
      );

      if (currentUrl.searchParams.toString() === before) {
        return false;
      }

      window.history.replaceState(
        window.history.state,
        '',
        `${currentUrl.pathname}${currentUrl.search}${currentUrl.hash}`
      );

      return true;
    },

    saleQuickFilterForm() {
      return document.querySelector(
        '#SaleFilters [data-sale-filter-form]'
      );
    },

    replaceParameterValue(
      parameters,
      name,
      value,
      enabled
    ) {
      const retainedValues = parameters
        .getAll(name)
        .filter((item) => item !== value);

      parameters.delete(name);

      retainedValues.forEach((item) => {
        parameters.append(name, item);
      });

      window.FAFQuickFilters?.sync?.(
        document.getElementById('QuickFilters'),
        null,
        parameters
      );

      if (enabled) {
        parameters.append(name, value);
      }

      return parameters;
    },

    saleQuickFilterParameters(changedInput = null) {
      const parameters = this.getCommittedParameters();
      const sizeParameter = 'filter.v.m.faf.in_stock';
      const genderParameter = 'filter.p.m.faf.new_gender';

      if (
        !(changedInput instanceof HTMLInputElement) ||
        !changedInput.name ||
        !changedInput.name.startsWith('filter.')
      ) {
        parameters.set(
          'sort_by',
          parameters.get('sort_by') ||
          this.sortBy ||
          this.defaultSort
        );

        return parameters;
      }

      const { name, value, checked } = changedInput;

      if (name === sizeParameter && value !== 'One Size') {
        const form = this.saleQuickFilterForm();

        if (form) {
          this.normaliseGenderedSaleSizes(
            changedInput,
            form
          );
        }

        let selectedSizes = parameters
          .getAll(sizeParameter)
          .filter(
            (item) =>
              item !== 'One Size' && item !== value
          );

        const selectedGender =
          changedInput.dataset.gender || '';

        const currentGender =
          parameters.get(genderParameter) || '';

        if (
          checked &&
          selectedGender &&
          currentGender &&
          currentGender !== selectedGender
        ) {
          const footwearValues = new Set(
            this.saleSizeInputs()
              .filter(
                (input) =>
                  input.dataset.sizeGroup === 'footwear'
              )
              .map((input) => input.value)
          );

          selectedSizes = selectedSizes.filter(
            (item) => !footwearValues.has(item)
          );
        }

        if (checked) {
          selectedSizes.push(value);
        }

        parameters.delete(sizeParameter);

        [...new Set(selectedSizes)].forEach((item) => {
          parameters.append(sizeParameter, item);
        });

        if (checked && selectedGender) {
          parameters.set(genderParameter, selectedGender);
        }

        this.normaliseSaleHelperParameters(parameters);
      } else {
        this.replaceParameterValue(
          parameters,
          name,
          value,
          checked
        );
      }

      parameters.set(
        'sort_by',
        parameters.get('sort_by') ||
        this.sortBy ||
        this.defaultSort
      );

      return parameters;
    },

    async applySaleQuickFilter({ input = null } = {}) {
      const parameters =
        this.saleQuickFilterParameters(input);

      this.sortBy =
        parameters.get('sort_by') || this.defaultSort;

      this.page = 1;

      await this.fetchResults({
        requestUrl: this.buildRequestUrl(parameters, 1),
        browserUrl: this.buildBrowserUrl(
          this.browserParameters(parameters)
        ),
        closeAfter: false,
      });
    },

    async clearSaleQuickFilters() {
      const parameters = this.getCommittedParameters();
      const form = this.saleQuickFilterForm();

      if (form) {
        form
          .querySelectorAll(
            'input[type="checkbox"][name^="filter."]'
          )
          .forEach((input) => {
            if (input.value === 'One Size') return;

            this.replaceParameterValue(
              parameters,
              input.name,
              input.value,
              false
            );
          });

        this.normaliseSaleHelperParameters(parameters);
      } else {
        [
          'filter.p.m.faf.search_colour',
          'filter.p.m.faf.type',
          'filter.v.m.faf.in_stock',
          'filter.p.m.faf.new_gender',
        ].forEach((name) => parameters.delete(name));
      }

      this.sortBy =
        parameters.get('sort_by') || this.defaultSort;

      parameters.set('sort_by', this.sortBy);

      this.page = 1;

      await this.fetchResults({
        requestUrl: this.buildRequestUrl(parameters, 1),
        browserUrl: this.buildBrowserUrl(
          this.browserParameters(parameters)
        ),
        closeAfter: false,
      });
    },

    setSaleFiltersBusy(isBusy) {
      const root = document.getElementById('SaleFilters');

      if (!root) return;

      root.toggleAttribute('aria-busy', isBusy);
      root.classList.toggle(
        'pointer-events-none',
        isBusy
      );
      root.classList.toggle('opacity-50', isBusy);
    },

    bindFilterInputListener() {
      const form = this.$refs.form;

      if (!form || this.filterInputHandler) return;

      this.filterInputHandler = (event) => {
        const target =
          event.target instanceof HTMLInputElement
            ? event.target
            : null;

        if (!target || target.type === 'hidden') {
          return;
        }

        if (
          this.saleMode &&
          target.name === 'filter.v.m.faf.in_stock'
        ) {
          this.normaliseGenderedSaleSizes(target, form);
        }

        this.dirty = true;
      };

      form.addEventListener('input', this.filterInputHandler);
    },

    unbindFilterInputListener() {
      const form = this.$refs.form;

      if (form && this.filterInputHandler) {
        form.removeEventListener(
          'input',
          this.filterInputHandler
        );
      }

      this.filterInputHandler = null;
    },

    pruneCollectionStateCache() {
      try {
        const remove = [];

        for (
          let index = 0;
          index < window.sessionStorage.length;
          index += 1
        ) {
          const key = window.sessionStorage.key(index);
          if (!key) continue;

          if (key.startsWith(LEGACY_PREFIX)) {
            remove.push(key);
            continue;
          }

          if (!key.startsWith(STATE_PREFIX)) continue;

          try {
            const payload = JSON.parse(
              window.sessionStorage.getItem(key) || '{}'
            );
            const savedAt = Number(payload.savedAt || 0);

            if (
              !savedAt ||
              Date.now() - savedAt > STATE_LIFETIME
            ) {
              remove.push(key);
            }
          } catch (error) {
            remove.push(key);
          }
        }

        remove.forEach((key) => {
          window.sessionStorage.removeItem(key);
        });
      } catch (error) {
        // Storage is optional.
      }
    },

    buildProductAnchor(card = null) {
      const cards = productCards();
      const target = card || nearestVisibleCard(cards);
      const index = Math.max(0, cards.indexOf(target));

      return {
        product: cardIdentity(target),
        index,
        viewportOffset: target
          ? target.getBoundingClientRect().top
          : 0,
        next: cards
          .slice(index + 1, index + 6)
          .map(cardIdentity),
        previous: cards
          .slice(Math.max(0, index - 5), index)
          .reverse()
          .map(cardIdentity),
      };
    },

    saveCollectionState({
      scrollY = window.scrollY || window.pageYOffset || 0,
      force = false,
      anchor = null,
    } = {}) {
      if (this.restoringPosition) return false;
      if (!force && (this.loading || this.loadingMore)) {
        return false;
      }

      const list = document.getElementById('productList');
      if (!list) return false;

      const state = {
        version: STATE_VERSION,
        savedAt: Date.now(),
        url: this.currentRelativeUrl(),
        page: Math.max(1, Number(this.page || 1)),
        scrollY: Math.max(0, Number(scrollY || 0)),
        mobileCols:
          Number(currentMobileCols || 2) === 1 ? 1 : 2,
        anchor: anchor || this.buildProductAnchor(),
      };

      return safeStorage.set(
        this.collectionStateKey(),
        JSON.stringify(state)
      );
    },

    readCollectionState() {
      try {
        const raw = safeStorage.get(
          this.collectionStateKey()
        );

        if (!raw) return null;

        const state = JSON.parse(raw);
        const valid =
          state &&
          state.version === STATE_VERSION &&
          state.url === this.currentRelativeUrl() &&
          Number.isFinite(Number(state.savedAt)) &&
          Date.now() - Number(state.savedAt) <=
          STATE_LIFETIME;

        if (!valid) {
          safeStorage.remove(this.collectionStateKey());
          return null;
        }

        return state;
      } catch (error) {
        safeStorage.remove(this.collectionStateKey());
        return null;
      }
    },

    async waitForCollectionIdle() {
      const startedAt = Date.now();

      while (
        (this.loading || this.loadingMore) &&
        Date.now() - startedAt < 10000
      ) {
        await new Promise((resolve) =>
          window.setTimeout(resolve, 50)
        );
      }
    },

    async loadToPage(targetPage) {
      const requestedPage = Math.min(
        MAX_RESTORE_PAGES,
        Math.max(1, Number(targetPage || 1))
      );

      while (this.page < requestedPage) {
        const pagination =
          document.getElementById('paginate');

        if (!pagination?.dataset?.nextUrl) break;

        await this.waitForCollectionIdle();

        const beforePage = this.page;
        await this.loadMore();

        if (this.page <= beforePage) break;
      }
    },

    findRestorationTarget(anchor = {}) {
      const cards = productCards();

      if (!cards.length) {
        return {
          target: null,
          originalMissing: false,
        };
      }

      const original = cards.find((card) =>
        sameIdentity(card, anchor.product)
      );

      if (original) {
        return {
          target: original,
          originalMissing: false,
        };
      }

      for (const identity of anchor.next || []) {
        const target = cards.find((card) =>
          sameIdentity(card, identity)
        );

        if (target) {
          return {
            target,
            originalMissing: true,
          };
        }
      }

      for (const identity of anchor.previous || []) {
        const target = cards.find((card) =>
          sameIdentity(card, identity)
        );

        if (target) {
          return {
            target,
            originalMissing: true,
          };
        }
      }

      const index = Math.min(
        cards.length - 1,
        Math.max(0, Number(anchor.index || 0))
      );

      return {
        target: cards[index] || cards[0],
        originalMissing: true,
      };
    },

    async positionAtTarget(
      target,
      viewportOffset,
      fallbackScrollY
    ) {
      await waitForLayout();

      if (!target) {
        window.scrollTo(
          0,
          Math.max(0, Number(fallbackScrollY || 0))
        );
        return;
      }

      const desiredOffset = Number.isFinite(
        Number(viewportOffset)
      )
        ? Number(viewportOffset)
        : 100;

      const position = () => {
        const top =
          window.scrollY +
          target.getBoundingClientRect().top -
          desiredOffset;

        window.scrollTo(0, Math.max(0, top));
      };

      position();

      // Correct one late image/layout shift without continuously fighting the user.
      window.setTimeout(() => {
        if (document.visibilityState === 'visible') {
          position();
        }
      }, 220);
    },

    async restoreCollectionState({
      restoreScroll = true,
      force = false,
    } = {}) {
      if (this.restoringPosition) return false;

      const state = this.readCollectionState();
      if (!state) return false;

      const navigationType =
        window.performance
          ?.getEntriesByType?.('navigation')?.[0]
          ?.type || '';

      let pendingReturn = null;

      try {
        pendingReturn = JSON.parse(
          safeStorage.get(RETURN_MARKER_KEY) || 'null'
        );
      } catch (error) {
        pendingReturn = null;
      }

      const referrerIsProduct = /\/products\//.test(
        document.referrer || ''
      );

      const pendingMatches = Boolean(
        pendingReturn &&
        pendingReturn.url === this.currentRelativeUrl() &&
        Date.now() -
        Number(pendingReturn.savedAt || 0) <=
        STATE_LIFETIME
      );

      if (
        !force &&
        navigationType !== 'back_forward' &&
        !(pendingMatches && referrerIsProduct)
      ) {
        return false;
      }

      this.restoringPosition = true;

      try {
        if (
          Number(state.mobileCols) !==
          Number(currentMobileCols || 2) &&
          typeof switchGridMobileCols === 'function'
        ) {
          switchGridMobileCols(
            Number(state.mobileCols) === 1 ? 1 : 2
          );
        }

        await this.loadToPage(state.page);

        let result = this.findRestorationTarget(
          state.anchor || {}
        );

        // Product order can shift during a sale. One extra page is a bounded
        // attempt to find the original/next anchor without replaying the full feed.
        if (
          result.originalMissing &&
          document.getElementById('paginate')?.dataset
            ?.nextUrl &&
          this.page <
          Math.min(
            MAX_RESTORE_PAGES,
            Number(state.page || 1) + 1
          )
        ) {
          await this.loadToPage(
            Number(state.page || 1) + 1
          );
          result = this.findRestorationTarget(
            state.anchor || {}
          );
        }

        if (restoreScroll) {
          await this.positionAtTarget(
            result.target,
            state.anchor?.viewportOffset,
            state.scrollY
          );
        }

        this.page = Math.max(
          this.page,
          Number(state.page || 1)
        );

        this.updateCollectionProgress();

        if (
          result.originalMissing &&
          state.anchor?.product
        ) {
          announce(
            'The item you viewed is no longer in this collection. ' +
            'You have been returned to the nearest available product.'
          );
        }

        safeStorage.remove(RETURN_MARKER_KEY);
        return true;
      } finally {
        this.restoringPosition = false;
      }
    },

    currentProductCount() {
      return document.querySelectorAll(
        '#productList .faf-product-card-render'
      ).length;
    },

    updateCollectionProgress({
      announce: shouldAnnounce = false,
      added = 0,
    } = {}) {
      const progress = document.querySelector(
        '[data-collection-progress]'
      );

      if (!progress) return;

      const shown = this.currentProductCount();
      const total = Number.parseInt(
        progress.dataset.total ||
        document.getElementById('ProductGridContainer')?.dataset
          ?.count ||
        '0',
        10
      );

      const displayedShown =
        total > 0 ? Math.min(shown, total) : shown;

      const shownNode = progress.querySelector(
        '[data-shown-count]'
      );

      const totalNode = progress.querySelector(
        '[data-total-count]'
      );

      const liveNode = document.querySelector(
        '[data-collection-progress-live]'
      );

      if (shownNode) {
        shownNode.textContent = String(displayedShown);
      }

      if (totalNode) {
        totalNode.textContent = String(total);
      }

      if (shouldAnnounce && added > 0 && liveNode) {
        liveNode.textContent =
          `${added} more ${added === 1 ? 'product' : 'products'} loaded. ` +
          `Showing ${displayedShown} of ${total}.`;
      }
    },

    updateLoadedPageUrl(page) {
      const resolvedPage = Math.max(1, Number(page) || 1);
      const browserUrl = new URL(window.location.href);

      // The loaded page depth is retained in session storage and history state.
      // Keeping ?page=2 in the visible URL causes Shopify to render only that
      // page following a refresh.
      browserUrl.searchParams.delete('page');

      window.history.replaceState(
        {
          ...(window.history.state || {}),
          collectionPage: resolvedPage,
          collectionShown: this.currentProductCount(),
        },
        '',
        `${browserUrl.pathname}${browserUrl.search}${browserUrl.hash}`
      );
    },

    lockScroll() {
      window.clearTimeout(this.unlockTimer);
      this.unlockTimer = null;

      if (this.scrollLocked) return;

      window.FAFScrollLock?.lock?.(this.scrollLockKey);
      this.scrollLocked = true;
    },

    releaseScrollLock(restoreFocus = true) {
      window.clearTimeout(this.unlockTimer);
      this.unlockTimer = null;

      if (this.scrollLocked) {
        window.FAFScrollLock?.unlock?.(this.scrollLockKey);
        this.scrollLocked = false;
      }

      if (!restoreFocus) return;

      const returnFocusElement = this.returnFocusElement;
      this.returnFocusElement = null;

      if (returnFocusElement?.isConnected) {
        window.requestAnimationFrame(() => {
          returnFocusElement.focus({ preventScroll: true });
        });
      }
    },

    transitionTimeMs(element) {
      if (!element) return 0;

      const style = window.getComputedStyle(element);

      const durations = style.transitionDuration
        .split(',')
        .map((value) => {
          const numericValue = Number.parseFloat(value) || 0;

          return value.trim().endsWith('ms')
            ? numericValue
            : numericValue * 1000;
        });

      const delays = style.transitionDelay
        .split(',')
        .map((value) => {
          const numericValue = Number.parseFloat(value) || 0;

          return value.trim().endsWith('ms')
            ? numericValue
            : numericValue * 1000;
        });

      const itemCount = Math.max(
        durations.length,
        delays.length
      );

      let longestTransition = 0;

      for (let index = 0; index < itemCount; index += 1) {
        const duration =
          durations[index % durations.length] || 0;

        const delay =
          delays[index % delays.length] || 0;

        longestTransition = Math.max(
          longestTransition,
          duration + delay
        );
      }

      return longestTransition;
    },

    scheduleScrollUnlock() {
      window.clearTimeout(this.unlockTimer);

      window.requestAnimationFrame(() => {
        const transitionTime = this.transitionTimeMs(
          this.$refs.dialog
        );

        this.unlockTimer = window.setTimeout(() => {
          if (!this.show) {
            this.releaseScrollLock();
          }
        }, transitionTime + 50);
      });
    },

    handleDialogTransitionEnd(event) {
      if (
        !this.show &&
        event.target === this.$refs.dialog &&
        (event.propertyName === 'transform' ||
          event.propertyName === 'opacity')
      ) {
        this.releaseScrollLock();
      }
    },

    openFilters() {
      if (this.show) return;

      this.returnFocusElement =
        document.activeElement instanceof HTMLElement
          ? document.activeElement
          : null;

      this.error = '';
      this.lockScroll();
      this.show = true;

      this.$nextTick(() => {
        this.$refs.closeButton?.focus({ preventScroll: true });
      });
    },

    closeFilters() {
      if (!this.show) return;

      this.show = false;
      this.scheduleScrollUnlock();
    },

    trapFocus(event) {
      const dialog = this.$refs.dialog;

      if (!dialog) return;

      const focusable = [
        ...dialog.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        ),
      ].filter(
        (element) =>
          !element.hidden && element.offsetParent !== null
      );

      if (focusable.length === 0) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (
        event.shiftKey &&
        document.activeElement === first
      ) {
        event.preventDefault();
        last.focus();
      } else if (
        !event.shiftKey &&
        document.activeElement === last
      ) {
        event.preventDefault();
        first.focus();
      }
    },

    selectedSortLabel() {
      const checked = this.$refs.form?.querySelector(
        'input[name="sort_by"]:checked'
      );

      return (
        checked?.nextElementSibling?.textContent?.trim() ||
        'Featured'
      );
    },

    getFormParameters() {
      const form = this.$refs.form;

      if (!form) return new URLSearchParams();

      const parameters = new URLSearchParams(
        new FormData(form)
      );

      const committedParameters = new URLSearchParams(
        window.location.search
      );

      // Price bounds can change after Material/Colour/Size filtering.
      // Preserve the committed price restriction unless the visitor
      // actually edited the price controls in this drawer.
      const priceRange = form.querySelector('[data-price-range]');
      if (priceRange?.dataset.priceTouched !== 'true') {
        for (const name of [
          'filter.v.price.gte',
          'filter.v.price.lte',
        ]) {
          parameters.delete(name);

          for (const value of committedParameters.getAll(name)) {
            if (value !== '') parameters.append(name, value);
          }
        }
      }

      ['filter.p.product_type'].forEach((name) => {
        if (parameters.has(name)) return;

        committedParameters.getAll(name).forEach((value) => {
          if (value !== '') {
            parameters.append(name, value);
          }
        });
      });

      if (this.saleMode) {
        this.applySaleSizeHelpers(parameters, form);
      }

      parameters.set(
        'sort_by',
        this.sortBy || this.defaultSort
      );

      for (const [key, value] of [
        ...parameters.entries(),
      ]) {
        if (value === '') {
          parameters.delete(key);
        }
      }

      return parameters;
    },

    getCommittedParameters() {
      const parameters = new URLSearchParams(
        window.location.search
      );

      parameters.delete('view');
      parameters.delete('page');
      parameters.delete('section_id');

      this.normaliseSaleHelperParameters(parameters);

      parameters.set(
        'sort_by',
        parameters.get('sort_by') ||
        this.sortBy ||
        this.defaultSort
      );

      return parameters;
    },

    browserParameters(parameters) {
      const browserParameters = new URLSearchParams(
        parameters.toString()
      );

      if (
        browserParameters.get('sort_by') ===
        this.defaultSort
      ) {
        browserParameters.delete('sort_by');
      }

      return browserParameters;
    },

    buildBrowserUrl(parameters) {
      const browserUrl = new URL(
        this.collectionPath || window.location.pathname,
        window.location.origin
      );

      const currentParameters = new URLSearchParams(
        window.location.search
      );

      const view = currentParameters.get('view');

      if (view) {
        browserUrl.searchParams.set('view', view);
      }

      for (const [key, value] of parameters.entries()) {
        browserUrl.searchParams.append(key, value);
      }

      return (
        browserUrl.pathname +
        (browserUrl.search ? browserUrl.search : '')
      );
    },

    buildRequestUrl(parameters, page = 1) {
      const requestUrl = new URL(
        this.collectionPath || window.location.pathname,
        window.location.origin
      );

      const view = new URLSearchParams(
        window.location.search
      ).get('view');

      if (view) {
        requestUrl.searchParams.set('view', view);
      }

      for (const [key, value] of parameters.entries()) {
        requestUrl.searchParams.append(key, value);
      }

      requestUrl.searchParams.set(
        'section_id',
        this.sectionId
      );
      requestUrl.searchParams.set('page', String(page));

      return requestUrl.toString();
    },

    async applyFilters({
      closeAfter = true,
      pushHistory = true,
    } = {}) {
      const parameters = this.getFormParameters();

      const browserUrl = this.buildBrowserUrl(
        this.browserParameters(parameters)
      );

      const requestUrl = this.buildRequestUrl(
        parameters,
        1
      );

      this.page = 1;

      await this.fetchResults({
        requestUrl,
        browserUrl: pushHistory ? browserUrl : null,
        closeAfter,
      });
    },

    async clearFilters() {
      const parameters = this.getCommittedParameters();

      for (const key of [...new Set(parameters.keys())]) {
        if (key.startsWith('filter.')) {
          parameters.delete(key);
        }
      }

      this.sortBy = this.defaultSort;
      parameters.set('sort_by', this.defaultSort);
      this.page = 1;
      this.dirty = false;

      const browserUrl = this.buildBrowserUrl(
        this.browserParameters(parameters)
      );

      const requestUrl = this.buildRequestUrl(
        parameters,
        1
      );

      await this.fetchResults({
        requestUrl,
        browserUrl,
        closeAfter: true,
      });
    },

    async fetchResults({
      requestUrl,
      browserUrl = null,
      closeAfter = false,
    }) {

      const quickFilterScroll = document.querySelector(
        '#QuickFilters [data-quick-filter-scroll]'
      );

      const quickFilterScrollLeft =
        quickFilterScroll?.scrollLeft ?? 0;
      this.requestController?.abort();
      this.loadMoreController?.abort();

      const controller = new AbortController();
      const grid = document.getElementById(
        'ProductGridContainer'
      );

      this.requestController = controller;
      this.loading = true;
      this.error = '';
      grid?.setAttribute('aria-busy', 'true');
      this.setSaleFiltersBusy(true);

      try {
        const response = await fetch(requestUrl, {
          signal: controller.signal,
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
          },
        });

        if (!response.ok) {
          throw new Error(
            `Products could not be loaded (${response.status}).`
          );
        }

        const responseText = await response.text();

        const responseDocument = new DOMParser().parseFromString(
          responseText,
          'text/html'
        );

        const incomingGrid =
          responseDocument.getElementById(
            'ProductGridContainer'
          );

        const currentGrid = document.getElementById(
          'ProductGridContainer'
        );

        if (!incomingGrid || !currentGrid) {
          throw new Error(
            'The product results returned an unexpected response.'
          );
        }

        currentGrid.innerHTML = incomingGrid.innerHTML;
        currentGrid.dataset.count =
          incomingGrid.dataset.count || '0';

        this.page = 1;

        this.updateResultsCount(
          Number.parseInt(
            currentGrid.dataset.count,
            10
          ) || 0
        );

        const incomingForm =
          responseDocument.querySelector(
            '[data-collection-filter-form]'
          );

        if (incomingForm && this.$refs.form) {
          this.$refs.form.innerHTML =
            incomingForm.innerHTML;
        }

        const incomingSaleFilters =
          responseDocument.getElementById('SaleFilters');

        const currentSaleFilters =
          document.getElementById('SaleFilters');

        if (
          incomingSaleFilters &&
          currentSaleFilters
        ) {
          currentSaleFilters.innerHTML =
            incomingSaleFilters.innerHTML;
        }

        const incomingQuickFilters =
          responseDocument.getElementById('QuickFilters');

        const currentQuickFilters =
          document.getElementById('QuickFilters');

        if (
          currentQuickFilters &&
          window.FAFQuickFilters?.sync
        ) {
          const syncParameters = new URL(
            requestUrl
          ).searchParams;

          syncParameters.delete('section_id');
          syncParameters.delete('page');

          window.FAFQuickFilters.sync(
            currentQuickFilters,
            incomingQuickFilters,
            syncParameters
          );

         if (quickFilterScroll?.isConnected) {
            quickFilterScroll.scrollLeft = quickFilterScrollLeft;

            requestAnimationFrame(() => {
              if (quickFilterScroll.isConnected) {
                quickFilterScroll.scrollLeft = quickFilterScrollLeft;
              }
            });
          }
        }

        if (browserUrl) {
          history.pushState(
            {
              collectionPage: 1,
              collectionShown:
                this.currentProductCount(),
            },
            '',
            browserUrl
          );
        }

        this.dirty = false;
        this.$dispatch('filtered');

        if (
          typeof translateRawSizeLabels === 'function'
        ) {
          translateRawSizeLabels();
        }

        this.$nextTick(() => {
          this.updateCollectionProgress();

          this.saveCollectionState({
            force: true,
          });

          const list =
            document.getElementById('productList');

          window.FAFAnalytics?.viewItemList(list, {
            list: window.location.pathname,
          });

          const parameters = new URL(
            requestUrl
          ).searchParams;

          window.FAFAnalytics?.custom(
            'faf_collection_results_updated',
            {
              collection: window.location.pathname,
              result_count:
                Number.parseInt(
                  currentGrid.dataset.count || '0',
                  10
                ),
              sort_by:
                parameters.get('sort_by') ||
                this.defaultSort,
              filter_count: [
                ...parameters.keys(),
              ].filter((key) =>
                key.startsWith('filter.')
              ).length,
            }
          );
        });

        if (closeAfter) {
          this.closeFilters();
        }
      } catch (error) {
        if (error.name !== 'AbortError') {
          this.error =
            error.message ||
            'Products could not be loaded. Please try again.';
        }
      } finally {
        if (
          this.requestController === controller
        ) {
          this.requestController = null;
          this.loading = false;

          document
            .getElementById('ProductGridContainer')
            ?.removeAttribute('aria-busy');

          this.setSaleFiltersBusy(false);
        }
      }
    },

    updateResultsCount(count) {
      document
        .querySelectorAll(
          '#ResultsCount, [data-results-count]'
        )
        .forEach((element) => {
          element.textContent =
            count === 0
              ? 'No products'
              : `${count} ${count === 1 ? 'product' : 'products'
              }`;
        });
    },

    async handleHistoryChange() {
      this.normaliseCurrentBrowserSaleHelpers();
      this.page = this.pageFromUrl();

      const restored =
        await this.restoreCollectionState();

      if (restored) return;

      const visibleParameters =
        new URLSearchParams(
          window.location.search
        );

      visibleParameters.delete('view');
      visibleParameters.delete('page');
      visibleParameters.delete('section_id');

      this.normaliseSaleHelperParameters(
        visibleParameters
      );

      this.sortBy =
        visibleParameters.get('sort_by') ||
        this.defaultSort;

      const requestUrl = this.buildRequestUrl(
        visibleParameters,
        1
      );

      await this.fetchResults({ requestUrl });
    },

    applyExternalSort(event) {
      if (!event?.target?.value) return;

      this.sortBy = event.target.value;
      this.applyFilters({ closeAfter: false });
      event.target.blur();
    },

async removeFilter({ name, value, url } = {}) {
  if (this.loading) return;

  // Support legacy/server-generated url_to_remove pills.
  if (url && !name) {
    const targetUrl = new URL(url, window.location.origin);
    const parameters = new URLSearchParams(targetUrl.search);

    this.sortBy =
      parameters.get('sort_by') ||
      this.sortBy ||
      this.defaultSort;

    parameters.set('sort_by', this.sortBy);

    this.page = 1;

    await this.fetchResults({
      requestUrl: this.buildRequestUrl(parameters, 1),
      browserUrl: this.buildBrowserUrl(
        this.browserParameters(parameters)
      ),
      closeAfter: false,
    });

    return;
  }

  if (!name) return;

  const parameters = this.getCommittedParameters();

  const remainingValues = parameters
    .getAll(name)
    .filter((item) => item !== value);

  parameters.delete(name);

  remainingValues.forEach((item) => {
    parameters.append(name, item);
  });

  const input = [
    ...(this.$refs.form?.elements || []),
  ].find(
    (element) =>
      element.name === name &&
      element.value === value
  );

    if (input) {
      // Removing a selected chip must not trigger the quick-filter toggle
      // handler: that handler would interpret a synthetic change as a new
      // selection and add the value straight back.
      input.checked = false;
    }

    window.FAFQuickFilters?.sync?.(
      document.getElementById('QuickFilters'),
      null,
      parameters
    );

    if (this.saleMode) {
      this.normaliseSaleHelperParameters(parameters);
    }

    this.sortBy =
      parameters.get('sort_by') ||
      this.sortBy ||
      this.defaultSort;

      parameters.set('sort_by', this.sortBy);

      this.page = 1;

      await this.fetchResults({
        requestUrl: this.buildRequestUrl(parameters, 1),
        browserUrl: this.buildBrowserUrl(
          this.browserParameters(parameters)
        ),
        closeAfter: false,
      });
    },

    async clearPriceFilter({ name } = {}) {
      const priceParameters = new Set([
        'filter.v.price.gte',
        'filter.v.price.lte',
      ]);

      if (!priceParameters.has(name)) return;

      const parameters =
        this.getCommittedParameters();

      parameters.delete(name);
      this.sortBy =
        parameters.get('sort_by') ||
        this.defaultSort;
      parameters.set('sort_by', this.sortBy);
      this.page = 1;

      const browserUrl = this.buildBrowserUrl(
        this.browserParameters(parameters)
      );

      const requestUrl = this.buildRequestUrl(
        parameters,
        1
      );

      await this.fetchResults({
        requestUrl,
        browserUrl,
        closeAfter: false,
      });
    },

    directSizeSearch({
      size = '',
      gender = '',
      productType = '',
    } = {}) {
      const parameters = new URLSearchParams();

      parameters.set(
        'filter.v.availability',
        '1'
      );
      parameters.set(
        'sort_by',
        this.sortBy || this.defaultSort
      );

      if (size) {
        parameters.append(
          'filter.v.option.size',
          size
        );

        if (gender) {
          parameters.append(
            'filter.p.m.faf.new_gender',
            gender
          );
        }
      } else if (productType) {
        parameters.append(
          'filter.p.m.faf.type',
          productType
        );
      }

      const requestUrl = this.buildRequestUrl(
        parameters,
        1
      );

      const browserUrl = this.buildBrowserUrl(
        this.browserParameters(parameters)
      );

      this.page = 1;

      this.fetchResults({
        requestUrl,
        browserUrl,
        closeAfter: true,
      });
    },

    async loadMore() {
      if (this.loadingMore || this.loading) return;

      const pagination =
        document.getElementById('paginate');
      const nextUrl = pagination?.dataset?.nextUrl;
      const currentList =
        document.getElementById('productList');

      if (!nextUrl || !currentList) return;

      this.loadMoreController?.abort();

      const controller = new AbortController();
      const requestUrl = new URL(
        nextUrl,
        window.location.origin
      );

      requestUrl.searchParams.set(
        'section_id',
        this.sectionId
      );

      const requestedPage = Number.parseInt(
        requestUrl.searchParams.get('page') ||
        String(this.page + 1),
        10
      );

      this.loadMoreController = controller;
      this.loadingMore = true;
      this.error = '';

      try {
        const response = await fetch(
          requestUrl.toString(),
          {
            signal: controller.signal,
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
            },
          }
        );

        if (!response.ok) {
          throw new Error(
            `More products could not be loaded (${response.status}).`
          );
        }

        const responseText = await response.text();

        const responseDocument =
          new DOMParser().parseFromString(
            responseText,
            'text/html'
          );

        const incomingList =
          responseDocument.getElementById(
            'productList'
          );

        const incomingPagination =
          responseDocument.getElementById(
            'paginate'
          );

        if (!incomingList) {
          throw new Error(
            'No additional products were returned.'
          );
        }

        const addedCount =
          incomingList.querySelectorAll(
            '.faf-product-card-render'
          ).length;

        const previousCardCount =
          currentList.querySelectorAll(
            '[data-elevar-product-card]'
          ).length;

        currentList.insertAdjacentHTML(
          'beforeend',
          incomingList.innerHTML
        );

        const allCards =
          currentList.querySelectorAll(
            '[data-elevar-product-card]'
          );

        const appendedCards = Array.from(
          allCards
        ).slice(previousCardCount);

        window.FAFAnalytics?.viewItemListCards(
          appendedCards,
          {
            list: window.location.pathname,
            startPosition: previousCardCount,
          }
        );

        window.FAFAnalytics?.custom(
          'faf_load_more_products',
          {
            collection: window.location.pathname,
            page: requestedPage,
            products_added: appendedCards.length,
            products_visible: allCards.length,
          }
        );

        if (incomingPagination && pagination) {
          pagination.outerHTML =
            incomingPagination.outerHTML;
        } else if (incomingPagination) {
          currentList.insertAdjacentHTML(
            'afterend',
            incomingPagination.outerHTML
          );
        } else {
          pagination?.remove();
        }

        this.page =
          Number.isFinite(requestedPage) &&
            requestedPage > 0
            ? requestedPage
            : this.page + 1;

        this.updateLoadedPageUrl(this.page);

        if (
          typeof translateRawSizeLabels === 'function'
        ) {
          translateRawSizeLabels();
        }

        this.updateCollectionProgress({
          announce: true,
          added: addedCount,
        });

        this.saveCollectionState({ force: true });
      } catch (error) {
        if (error.name !== 'AbortError') {
          this.error =
            error.message ||
            'More products could not be loaded. Please try again.';
        }
      } finally {
        if (
          this.loadMoreController === controller
        ) {
          this.loadMoreController = null;
          this.loadingMore = false;

          window.dispatchEvent(
            new CustomEvent('load-more-complete')
          );
        }
      }
    },
  };
}